module.exports = __webpack_public_path__ + "cababe2e09ca114b42f5c31d6ea41056.png";